import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./style.css";

const VehicleDetails = ({
  ropLicense,
  ropVehicle,
  valuationData,
  selectedProduct,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
  }, [ropLicense, ropVehicle, valuationData]);

  const vehicleInfo =
    ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult?.VehicleInfo || {};

  return ropLicense && ropVehicle ? (
    <section className="container my-3">
      {
      //  <div className="card shadow-sm border-0 rounded-3">
      //   <div className="card-header bg-warning text-dark fw-bold d-flex align-items-center">

      
      //     <i
      //       className="bi bi-house-fill"
      //       style={{ cursor: "pointer" }}
      //       onClick={() => navigate("/")}
      //     ></i>
      //     <i className="bi bi-car-front me-2 ms-4"></i>
      //     {t("yourVehicleDetails")}
      //   </div>
      //   <div className="card-body">
      //     <div className="alert alert-warning py-2 mb-3 text-dark">
      //       {t("yourSelection")}
      //       <strong>
      //         {selectedProduct && selectedProduct?.sub_product_id === 21
      //           ? t("motor-comprehensive-insurance")
      //           : t("motor-thirdparty-insurance")}
      //       </strong>
      //     </div>

      //     <div className="row g-3">
      //       <div className="col-6 col-md-4">
      //         <small className="text-muted">{t("plate-number")}</small>
      //         <p className="mb-0 fw-semibold">
      //           <i className="bi bi-hash me-2 text-warning"></i>
      //           {vehicleInfo?.PlateNumber || "-"}
      //         </p>
      //       </div>
      //       <div className="col-6 col-md-4">
      //         <small className="text-muted">{t("plate-character")}</small>
      //         <p className="mb-0 fw-semibold">
      //           {vehicleInfo?.PlateCode || "-"}
      //         </p>
      //       </div>
      //       <div className="col-6 col-md-4">
      //         <small className="text-muted">{t("make-description")}</small>
      //         <p className="mb-0 fw-semibold">
      //           <i className="bi bi-tags me-2 text-warning"></i>
      //           {vehicleInfo?.VehicleMakeDesc || "-"}
      //         </p>
      //       </div>
      //       <div className="col-6 col-md-4">
      //         <small className="text-muted">{t("model-description")}</small>
      //         <p className="mb-0 fw-semibold">
      //           {vehicleInfo?.VehicleModelDesc || "-"}
      //         </p>
      //       </div>
      //       <div className="col-6 col-md-4">
      //         <small className="text-muted">
      //           {t("vehicle-type-description")}
      //         </small>
      //         <p className="mb-0 fw-semibold">
      //           {vehicleInfo?.VehicleTypeDesc || "-"}
      //         </p>
      //       </div>
      //       <div className="col-6 col-md-4">
      //         <small className="text-muted">{t("previous-policy-type")}</small>
      //         <p className="mb-0 fw-semibold">
      //           <i className="bi bi-file-text me-2 text-warning"></i>
      //           {vehicleInfo?.InsuranceTypeDesc || "-"}
      //         </p>
      //       </div>
      //     </div>
      //   </div>
      // </div> 
    }
   <div className="card-body p-0 py-2 vehicle-details-bar" style={{ backgroundColor: "#e9e7e7" }}>
        <div className="vehicle-details-row" style={{ display: "flex", maxHeight: "80px" }}>

          <div
            className="vehicle-details-item vd-plate"
            style={{
              flex: "0 0 10%",
              borderRight: "1px solid #d0d0d0",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              textAlign: "end",
            }}
          >
            <label style={{
              fontSize: "12px",
              color: "#666",
              fontWeight: "400",
              marginRight: "14px",
              letterSpacing: "0.1px"
            }}>
              {t("plate-number")}
            </label>
            <p style={{
              margin: "0",
              fontSize: "16px",
              fontWeight: "500",
              color: "#333",
              marginRight: "14px",
              lineHeight: "0.8"
            }}>
              <span>{vehicleInfo?.PlateNumber || "-"}</span>
              <span style={{ color: "#333", fontWeight: "500" }}> / {vehicleInfo?.PlateCode || "-"}</span>
            </p>
          </div>

          <div
            className="vehicle-details-item"
            style={{
              flex: "0 0 10%",
              borderRight: "1px solid #d0d0d0",
              display: "flex",
              paddingLeft: "12px",
              paddingBottom: "4px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
              textAlign: "center",
            }}
          >
            <label style={{
              fontSize: "12px",
              color: "#666",
              marginBottom: "4px",
              fontWeight: "400",
              letterSpacing: "0.1px"
            }}>
              {t("make-description")}
            </label>
            <p style={{
              margin: "0",
              fontSize: "16px",
              fontWeight: "500",
              color: "#333",
              lineHeight: "0.8"
            }}>
              {vehicleInfo?.VehicleMakeDesc || "-"} / {vehicleInfo?.VehicleModelDesc || "-"}
            </p>
          </div>

          <div
            className="vehicle-details-item"
            style={{
              flex: "0 0 15%",
              borderRight: "1px solid #d0d0d0",
              display: "flex",
              paddingLeft: "12px",
              paddingBottom: "4px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
              textAlign: "center",
            }}
          >
            <label style={{
              fontSize: "12px",
              color: "#666",
              marginBottom: "4px",
              fontWeight: "400",
              letterSpacing: "0.1px"
            }}>
              {t("vehicle-type-description")}
            </label>
            <p style={{
              margin: "0",
              fontSize: "16px",
              fontWeight: "500",
              color: "#333",
              lineHeight: "0.8"
            }}>
              {vehicleInfo?.VehicleTypeDesc || "-"}
            </p>
          </div>

          <div
            className="vehicle-details-item"
            style={{
              flex: "0 0 25%",
              borderRight: "1px solid #d0d0d0",
              display: "flex",
              paddingLeft: "12px",
              paddingBottom: "4px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
              textAlign: "center",
            }}
          >
            <label style={{
              fontSize: "12px",
              color: "#666",
              marginBottom: "4px",
              fontWeight: "400",
              letterSpacing: "0.1px"
            }}>
              {t("previous-policy-type")}
            </label>
            <p style={{
              margin: "0",
              fontSize: "16px",
              fontWeight: "500",
              color: "#333",
              lineHeight: "0.8"
            }}>
              {vehicleInfo?.InsuranceTypeDesc || "-"}
            </p>
          </div>

          <div
            style={{
              padding: "6px",
              flex: "1",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <div style={{
              display: "flex",
              gap: "12px",
              alignItems: "flex-start"
            }}>
              <div style={{ flex: 1 }}>
                <p style={{
                  margin: "0 0 0 0",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#333"
                }}>
                </p>
                <p style={{
                  margin: "0",
                  fontSize: "13px",
                  color: "#555",
                  lineHeight: "1.5"
                }}>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
  
    </section>
  ) : null;
};

export default VehicleDetails;


    